import { BehaviorSubject, Subject } from 'rxjs';
import { MotionMasterPubSubSocket } from './motion-master-pub-sub-socket';
import { IMotionMasterMessage } from './types';
import { logger } from './logger';

export class MotionMasterPubSubWorkerSocket implements MotionMasterPubSubSocket {
  opened$ = new BehaviorSubject(false);

  close$ = new Subject<{ code: number; reason: string }>();

  data$ = new Subject<[string, IMotionMasterMessage]>();

  private _url?: string;

  constructor(public readonly worker: Worker) {}

  get url(): string | undefined {
    return this._url;
  }

  open(url: string): void {
    this._url = url;

    this.worker.onmessage = ({ data }) => {
      if ('opened' in data) {
        const { opened } = data;
        this.opened$.next(opened);
        logger.info(opened ? `Opened pub/sub 🔌 ${url}` : `Closed pub/sub 🔌 ${url}`);
      } else if ('topic' in data) {
        const { topic, messages }: { topic: string; messages: IMotionMasterMessage[] } = data;
        messages.forEach((message) => this.data$.next([topic, message]));
      } else if ('close' in data) {
        const { close } = data;
        this.close$.next(close);
        logger.info(`Close event received on pub/sub 🔌 ${url} ${JSON.stringify(close)}`);
      }
    };

    this.worker.postMessage({
      open: { url },
    });
  }

  close(): void {
    this.worker.postMessage({ close: true });
  }

  reopen() {
    if (this.url && this.opened$.value === false) {
      this.open(this.url);
    }
  }
}
